import React, { useState } from 'react';

interface Props {
    label?: string;
    onChange?: () => {},
    name?: string
}

export default function Input({label, onChange, name }: Props) {
    const [value, setValue] = useState('');

    return (
        <div className='flex flex-col gap-1'>
            {!!label && <label className="text-gray-900 text-sm font-medium">
                {label}
            </label>}
            <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={`Your ${label || name || ""}`}
                className='placeholder:text-sm'
                style={{
                    border: "1px solid #E2E8F1",
                    borderRadius: "14px",
                    backgroundColor: "#FFF",
                    display: "flex",
                    padding: "10px",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%"
                }}
            />
        </div>
    );
}